var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/profile-2user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 2.6001C6.38 2.6001 4.25 4.7301 4.25 7.3501C4.25 9.9201 6.26 12.0001 8.88 12.0901C8.96 12.0801 9.04 12.0801 9.1 12.0901C9.12 12.0901 9.13 12.0901 9.15 12.0901C9.16 12.0901 9.16 12.0901 9.17 12.0901C11.73 12.0001 13.74 9.9201 13.75 7.3501C13.75 4.7301 11.62 2.6001 9 2.6001Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.08 14.75C11.29 12.89 6.73996 12.89 3.92996 14.75C2.65996 15.6 1.95996 16.75 1.95996 17.98C1.95996 19.21 2.65996 20.35 3.91996 21.19C5.31996 22.13 7.15996 22.6 8.99996 22.6C10.84 22.6 12.68 22.13 14.08 21.19C15.34 20.34 16.04 19.2 16.04 17.96C16.03 16.73 15.34 15.59 14.08 14.75Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.9904 7.9402C20.1504 9.8802 18.7704 11.5802 16.8604 11.8102C16.8504 11.8102 16.8504 11.8102 16.8404 11.8102H16.8104C16.7504 11.8102 16.6904 11.8102 16.6404 11.8302C15.6704 11.8802 14.7804 11.5702 14.1104 11.0002C15.1404 10.0802 15.7304 8.7002 15.6104 7.2002C15.5404 6.3902 15.2604 5.6502 14.8404 5.0202C15.2204 4.8302 15.6604 4.7102 16.1104 4.6702C18.0704 4.5002 19.8204 5.9602 19.9904 7.9402Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.9902 17.19C21.9102 18.16 21.2902 19 20.2502 19.57C19.2502 20.12 17.9902 20.38 16.7402 20.35C17.4602 19.7 17.8802 18.89 17.9602 18.03C18.0602 16.79 17.4702 15.6 16.2902 14.65C15.6202 14.12 14.8402 13.7 13.9902 13.39C16.2002 12.75 18.9802 13.18 20.6902 14.56C21.6102 15.3 22.0802 16.23 21.9902 17.19Z",
    fill: "#6C84F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.2293c6e5301f117b7b691001bc0fed5f.svg";
export { ForwardRef as ReactComponent };